import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import PartialDepPlot from "components/RunPlot/PartialDepPlot";

class PartialDepPlotContainer extends React.PureComponent {
  render() {
    const {} = this.props;

    return <PartialDepPlot {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(PartialDepPlotContainer);
